
export class Contract {
    Code: string;
    Name: String;

    static mapFromJSON(json) {
        const m = new Contract();

        m.Code = json['code'];
        m.Name = json['name'];

        return m;
    }
}
